import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Grid, IconButton, Button, Tooltip } from '@mui/material';

import MuiIconUtil from '../../common/utils/muiIconUtil'

export default function ProductButtonContainter({ files, filesProp, downloadFile, setViewer, setFileToView, setPdfModalTitle }) {

    /** HANDLE */
    const handleDownloadClick = async (name, code, reference, ispublic) => {
        if (!name || !reference) return;
        setPdfModalTitle(name)
        setFileToView(await downloadFile(code, reference))
        setViewer(true)
    };

    if (!filesProp) return null;

    return (
        <Grid container className='justify-content-center text-center pb-4' id={"legacy-product-buttons"}>
            {filesProp.map(fileproperty => {
                const certData = files[fileproperty.reference];
                if (certData)
                    return (
                        <Button
                            key={fileproperty.reference}
                            className={"btn-download m-2 px-3"}
                            variant="outlined"
                            onClick={() => handleDownloadClick(certData?.name || null, certData?.code || null, fileproperty.reference, fileproperty.public)}
                        >
                            <MuiIconUtil iconName={"DescriptionOutlined"} />
                            <span className="button-text ms-2">{certData?.name}</span>
                        </Button>
                    )
            })}
        </Grid>
    );
}